"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";

export default function WhatsAppInvite() {
    const rawNumber = process.env.NEXT_PUBLIC_FANCLUB_WHATSAPP_NUMBER || "";
    // const prefill = process.env.NEXT_PUBLIC_FANCLUB_WHATSAPP_PREFILL || "";
    const cleanNumber = rawNumber.replace(/[^0-9]/g, "");

    // Use rawNumber directly as it is provided in the desired format (+49 1579 245 4138)
    const displayNumber = rawNumber;

    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(rawNumber);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="w-full text-center space-y-12 py-24 px-6 md:px-0">
            <div className="space-y-4">
                <h2 className="font-display text-2xl text-[#2C2C2C] italic">
                    When you’re ready
                </h2>
                <div className="space-y-2 font-sans text-sm text-neutral-600 leading-relaxed">
                    <p>
                        If you’d like to begin,<br />
                        there’s a simple way to step inside.
                    </p>
                    <p>
                        One message is enough.
                    </p>
                </div>
            </div>

            <div className="flex flex-col items-center gap-6 max-w-xs mx-auto">
                <div className="font-mono text-xl text-[#2C2C2C] tracking-wider pb-4 border-b border-neutral-300 w-full">
                    {displayNumber || "+49 ••• ••• •••"}
                </div>

                <a
                    href={`https://wa.me/${cleanNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group w-full py-4 bg-[#2C2C2C] hover:bg-neutral-800 transition-colors"
                >
                    <span className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-[#EAE8E4]">
                        Open WhatsApp
                    </span>
                </a>

                <button
                    onClick={handleCopy}
                    className="w-full py-4 border border-neutral-400 hover:border-[#2C2C2C] transition-colors"
                >
                    <span className="font-sans text-[10px] font-bold uppercase tracking-[0.2em] text-neutral-600 hover:text-[#2C2C2C] transition-colors">
                        {copied ? "Number Copied" : "Copy Number"}
                    </span>
                </button>

                <p className="text-[10px] uppercase tracking-widest text-neutral-500">
                    A private conversation,<br />
                    one step closer.
                </p>
            </div>
        </div>
    );
}
